import { 
    CONTRACT_TYPE_GET_REQUEST, CONTRACT_TYPE_GET_SUCCESS, CONTRACT_TYPE_GET_ERROR, 
    CONTRACT_TYPE_GET_BY_KEY_REQUEST, CONTRACT_TYPE_GET_BY_KEY_SUCCESS, CONTRACT_TYPE_GET_BY_KEY_ERROR, 
    CONTRACT_TYPE_ADD_REQUEST, CONTRACT_TYPE_ADD_SUCCESS, CONTRACT_TYPE_ADD_ERROR, 
    CONTRACT_TYPE_EDIT_REQUEST, CONTRACT_TYPE_EDIT_SUCCESS, CONTRACT_TYPE_EDIT_ERROR, 
    CONTRACT_TYPE_DELETE_REQUEST, CONTRACT_TYPE_DELETE_SUCCESS, CONTRACT_TYPE_DELETE_ERROR
} from "../constants/contractTypeConstants";

const initialState = {
    contractTypes: [],
    contractType: {},
    loading: false,
    success: null,
    error: null,
    contractTypeRequestedCount: 0,
};

export const contractTypeReducer = (state = initialState, action) => {
    switch (action.type)     {
        case CONTRACT_TYPE_GET_REQUEST:
            return {
                ...state,
                contractTypeRequestedCount: ++state.contractTypeRequestedCount,
                loading: true,
            };
        case CONTRACT_TYPE_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                contractTypes: action.payload,
                success: true,
            };
        case CONTRACT_TYPE_GET_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case CONTRACT_TYPE_GET_BY_KEY_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case CONTRACT_TYPE_GET_BY_KEY_SUCCESS:
            return {
                ...state,
                loading: false,
                contractType: action.payload,
                success: true,
            };
        case CONTRACT_TYPE_GET_BY_KEY_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case CONTRACT_TYPE_ADD_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case CONTRACT_TYPE_ADD_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case CONTRACT_TYPE_ADD_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case CONTRACT_TYPE_EDIT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case CONTRACT_TYPE_EDIT_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case CONTRACT_TYPE_EDIT_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case CONTRACT_TYPE_DELETE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case CONTRACT_TYPE_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case CONTRACT_TYPE_DELETE_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        default:
            return state;
    }
}
